module.exports = __webpack_public_path__ + "img/default_user.4dbbb887.png";